import { createContext, useState } from "react";

const SubscriptionModalContext = createContext({ isSubscriptionModalOpen: false });

export const withSubscriptionModalContext = (Component) => (props) => {
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

  return (
    <SubscriptionModalContext.Provider
      value={{
        isSubscriptionModalOpen,
        setIsSubscriptionModalOpen,
      }}
    >
      <Component {...props} />
    </SubscriptionModalContext.Provider>
  );
};

export default SubscriptionModalContext;

